/* eslint no-restricted-properties: 0 */

angular.module('filters')
    .filter('formatSize', () => {

        let displayFormat;

        function display(size, type, digits) {

            switch (displayFormat) {

            case 'type':
                return type;
            case 'short':
                return parseFloat(size.toFixed(digits));
            default:
                return parseFloat(size.toFixed(digits)) + type;

            }

        }

        return (size, units, format) => {

            let cSize;
            let multiplier = 1;
            const digits = 1;

            displayFormat = format || 'long';
            units = units || 'b';

            switch (units) {

            case 'kb':
                multiplier = 1024;
                break;
            case 'mb':
                multiplier = 1024 * 1024;
                break;
            case 'gb':
                multiplier = Math.pow(1024, 3);
                break;
            default:
                multiplier = 1024;

            }

            size *= multiplier;

            cSize = size / Math.pow(1024, 4); // TB

            if (cSize > 0.5) {

                return display(cSize, 'TB', digits);

            }

            cSize = size / Math.pow(1024, 3); // GB
            if (cSize > 0.5) {

                return display(cSize, 'GB', digits);

            }
            cSize = size / (1024 * 1024); // MB
            if (cSize > 0.5) {

                return display(cSize, 'MB', digits);

            }
            cSize = size / 1024; // KB
            if (cSize > 0.5) {

                return display(cSize, 'KB', digits);

            }

            return display(size, units.toLocaleUpperCase(), digits);

        };

    });



// WEBPACK FOOTER //
// ./scripts/common/filters/formatSize.js